// @ts-nocheck 
import { Instance } from 'mobx-state-tree';
import { OrderModelBase } from './OrderModel.base';
import { PlanCategory } from './PlanCategoryEnum';
import _ from 'lodash';

/* The TypeScript type of an instance of OrderModel */
export interface OrderModelType extends Instance<typeof OrderModel.Type> {}

/* A graphql query fragment builders for OrderModel */
export {
  selectFromOrder,
  orderModelPrimitives,
  OrderModelSelector,
} from './OrderModel.base';

/**
 * OrderModel
 *
 * Order
 */
export const OrderModel = OrderModelBase.actions((self) => ({
  // This is an auto-generated example action.
  log() {
    console.log(JSON.stringify(self));
  },
})).views((self) => ({
  get numberOfItems(): number {
    return _.sumBy(self.orderPlans, 'numberOfItems');
  },
  get menuBuilderPlan(): OrderPlan | undefined {
    return _.find(self.orderPlans, { category: PlanCategory.MENU });
  },
  get isSubscription() {
    return self.frequency !== Frequency.ONCE;
  },
  get menuBuilderItems() {
    const menuBuilderPlan = this.menuBuilderPlan;
    const lineItems = menuBuilderPlan?.lineItems;
    return lineItems;
  },
  get cartList() {
    const orderPlans = _.filter(
      self.orderPlans,
      (plan) => plan.category !== PlanCategory.MENU
    );
    const items = this.menuBuilderItems;

    const data = [
      { title: 'Order Plans', data: orderPlans },
      { title: 'Gift Cards', data: self.giftCertificates },
      { title: 'Menu Builder', data: items },
    ];

    return data;
  },
}));
